const cols = [
  {
    head: '灵感分区',
    links: ['封面黑底风', '海报撞色派', '版式大字流', '暗调人像档', '复古印刷册', '胶片噪点集'],
  },
  {
    head: '配色 / 调色',
    links: ['炭暖橙配色卡', '海报配色方案', '暗调配色卡', '调色参数库', '色号速查', '风格灵感'],
  },
  {
    head: '关于黑料色',
    links: ['灵感收录说明', '更新日志', '调色术语表', '合作与投稿', '版权声明', '联系我们'],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-300/70 bg-background-200/70">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-14 md:px-6 md:pt-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* brand */}
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-foreground-950 text-lg font-bold text-primary-300">
                黑
              </span>
              <span className="font-display text-xl font-bold tracking-tight text-foreground-950">
                黑料色灵感库
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              专注整理封面、海报与版式设计中的配色与调色参考。做图没灵感时来翻黑料色，
              风格案例、版式参考与配色参数集中一处，看中直接套用，省下磨颜色的时间。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['#封面灵感', '#海报配色', '#版式参考', '#调色参数'].map((t) => (
                <a
                  key={t}
                  href="#cover"
                  className="flex h-7 cursor-pointer items-center whitespace-nowrap rounded-full border border-background-300/80 bg-background-50 px-3 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  {t}
                </a>
              ))}
            </div>
          </div>

          {/* link cols */}
          {cols.map((c) => (
            <div key={c.head} className="lg:col-span-2">
              <h4 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
                {c.head}
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {c.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#cover"
                      className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 黑料色 · 黑料色封面海报版式配色风格调色灵感参考站
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-refresh-line text-primary-500" />
              每周上新灵感
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-eye-2-line text-primary-500" />
              榜上热档持续更新
            </span>
            <span>内容仅供学习参考</span>
          </div>
        </div>
      </div>
    </footer>
  );
}